var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPalomita(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;fill-opacity:0;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,11.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l3,3c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l7-8 c0.3-0.4,0.3-1.1-0.2-1.4c-0.4-0.3-1-0.3-1.3,0.1L12,13.5L9.7,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,11c-0.6,0-1,0.4-1,1c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-2.1,0.8-4.1,2.3-5.6C7.8,4.8,9.9,4,12,4 c0.6,0,1.3,0.1,1.9,0.2c0.5,0.2,1.1-0.1,1.3-0.7S15,2.5,14.5,2.3c0,0-0.1,0-0.1,0C13.6,2.1,12.8,2,12,2C6.5,2,2,6.5,2.1,12.1 c0,2.6,1.1,5.2,2.9,7c1.9,1.9,4.4,2.9,7,2.9c5.5,0,10-4.5,10-10C22,11.4,21.6,11,21,11z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalomita);
export default __webpack_public_path__ + "static/media/Palomita.4e89ab7bd9158729cf38afb9364be98d.svg";
export { ForwardRef as ReactComponent };